module.exports = __webpack_public_path__ + "img/hzico_9.d22c42cc.jpg";